import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'

// Import Font Awesome core and icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { 
  faMapMarkerAlt, 
  faEnvelope, 
  faPhoneAlt, 
  faLaptopCode, 
  faMobileAlt, 
  faCloud, 
  faShieldAlt, 
  faChartLine, 
  faHeadset, 
  faUserGear,
  faBullseye,
  faHandshake 
} from '@fortawesome/free-solid-svg-icons'
import { faLinkedinIn, faInstagram, faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Add icons to the library (solid + brands)
library.add(
  faMapMarkerAlt,
  faEnvelope,
  faPhoneAlt,
  faLaptopCode,
  faMobileAlt,
  faCloud,
  faShieldAlt,
  faChartLine,
  faHeadset,
  faUserGear,
  faBullseye,
  faHandshake,
  // brands
  faLinkedinIn,
  faInstagram,
  faFacebookF,
  faTwitter
)

// Import views
import HomeView from './views/Home.vue'
import ContactView from './views/Contact.vue'
import AboutView from './views/About.vue'
import ServicesView from './views/Services.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import CareersView from './views/Careers.vue'
import ProductsView from './views/Products.vue'
import IDCardView from './views/IDChip.vue'

// Create router instance
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomeView
    },
    {
      path: '/services',
      name: 'Services',
      component: ServicesView
    },
    {
      path: '/contact',
      name: 'Contact',
      component: ContactView
    },
    {
      path: '/about',
      name: 'About',
      component: AboutView
    },
    {
      path: '/careers',
      name: 'Careers',
      component: CareersView
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/products',
      name: 'Products',
      component: ProductsView
    },
    {
      path: '/products/id-card',
      name: 'IDCard',
      component: IDCardView
    },
    // Add more routes here as needed
  ],
  scrollBehavior() {
    // Always scroll to top when navigating to a new route
    return { top: 0 }
  }
})

const app = createApp(App)

// Register Font Awesome component globally
app.component('font-awesome-icon', FontAwesomeIcon)

app.use(router)
app.mount('#app')

// Global styles
import './assets/main.css'
